import axios, { AxiosError } from "axios";
import { memo, useCallback, useState } from "react";
import { useQuery } from "react-query";
import { API_URL } from "../consts";
import { Messaggio } from "../prismaTypes";
import { oraPrenotaStore } from "../oraPrenotaStore";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

export const LoginDialog = memo(function LoginDialog() {
  const setM = oraPrenotaStore((state) => state.setMessaggi);
  const messaggi = oraPrenotaStore((state) => state.messaggi);

  const { isLoading, data } = useQuery<unknown, AxiosError, { messaggi: Messaggio[] }>(
    ["messaggi/onLogin"],
    () => axios.get(API_URL + "messaggi/onLogin").then((res) => res.data),
    {
      refetchInterval: 24 * 3600,
      enabled: !messaggi,
      onSuccess(data) {
        setM(true);
      },
    }
  );

  if (isLoading) return <></>;

  return (
    <>
      {data?.messaggi.map((m) => (
        <MessaggioDialog key={m.id} mess={m} />
      ))}
    </>
  );
});
export const MessaggioDialog = memo(function MessaggioDialog(props: { mess: Messaggio }) {
  const { mess } = props;
  const [open, setOpen] = useState(true);
  const handleClose = useCallback(() => setOpen(false), [setOpen]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{mess.titolo}</DialogTitle>
      <DialogContent className="preWrap">{mess.testo}</DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          Chiudi
        </Button>
      </DialogActions>
    </Dialog>
  );
});
